export function  getQuery(queryData) {
    if (!queryData) {
        return '';
    }
    const esc = encodeURIComponent;
    const query = Object.keys(queryData)
        .map(k => {
            var q =[]
            if(queryData[k] !== null){
                if(Array.isArray(queryData[k])){
                    queryData[k].forEach(element => {
                        q.push(esc(k) + '=' + esc(element)) 
                    });
                   return q.join('&')
                }
                else{
                    return esc(k) + '=' + esc(queryData[k])
                }
            } 
            else{
                return esc(k) + '='
            }
        }).join('&')
    return '?' + query;
}


    export function  getUrl(baseUrl, queryData) {
        var url = '/' + window.HSLU.scLanguage + baseUrl;
        var query = getQuery(queryData);
        return url + query;
    }

    export function  getCampusApiKeyHeader(campusApiKey, campusApiSecret) {
        var headers = {}
        if (campusApiKey) {
            headers["Campus_Api_Key"] = campusApiKey;
        }
        if (campusApiSecret) {
            headers["Campus_Api_Secret"] = campusApiSecret;
        }
        return headers
    }

    export function getOptionsWithApiKeyHeader(campusApiKey, campusApiSecre){
        var config = { headers: {} }
        config.headers = getCampusApiKeyHeader(campusApiKey, campusApiSecre)
        return config
    }